export default __webpack_public_path__ + "static/media/023-radioactive.a663169e.svg";